import React from 'react'
import {Navbar} from '../Components/Navbar'
import {Footer} from '../Components/Footer'
export const Checkout = () => {
  return (
    <div>
      <Navbar/>
      <h1>checkout</h1>
    <Footer/>
      </div>
  )
}
